export var AdminMembersEvents;
(function (AdminMembersEvents) {
    AdminMembersEvents["CLICK_ADD_MEMBERS"] = "workportal_click_add_members";
    AdminMembersEvents["ADD_EMPLOYEES_SUCCESS"] = "work_portal_add_employees_success";
    AdminMembersEvents["ADD_EMPLOYEES_FAILURE"] = "work_portal_add_employees_failure";
    AdminMembersEvents["ADD_EMPLOYEES_CANNOT_BE_ADDED"] = "work_portal_add_employees_cannot_be_added";
})(AdminMembersEvents || (AdminMembersEvents = {}));
export var BillingEvents;
(function (BillingEvents) {
    BillingEvents["VIEW_PAYMENT_METHODS"] = "workportal_view_payment_methods";
})(BillingEvents || (BillingEvents = {}));
export var BillingPaymentCardEvents;
(function (BillingPaymentCardEvents) {
    BillingPaymentCardEvents["ADD_CARD_CLICK"] = "ddfw_payment_add_card_click";
    BillingPaymentCardEvents["DELETE_CARD_CLICK"] = "ddfw_payment_delete_card_click";
    BillingPaymentCardEvents["DELETE_CARD_SUCCESS"] = "ddfw_payment_delete_card_success";
    BillingPaymentCardEvents["SET_DEFAULT_CARD_CLICK"] = "ddfw_payment_set_default_card_click";
    BillingPaymentCardEvents["SUPPORT_LINK_CLICK"] = "ddfw_payment_support_link_click";
})(BillingPaymentCardEvents || (BillingPaymentCardEvents = {}));
export var BillingPaymentCardTrackingEvents;
(function (BillingPaymentCardTrackingEvents) {
    BillingPaymentCardTrackingEvents["ADD_METHOD_MODAL_LOAD"] = "ddfw_payment_add_method_modal_load";
    BillingPaymentCardTrackingEvents["ADD_METHOD_CLICK"] = "ddfw_payment_add_method_click";
    BillingPaymentCardTrackingEvents["ADD_METHOD_FAILURE"] = "ddfw_payment_add_method_failure";
    BillingPaymentCardTrackingEvents["ADD_METHOD_SUCCESS"] = "ddfw_payment_add_method_success";
    BillingPaymentCardTrackingEvents["ADD_MODAL_TAPPED_BACK"] = "ddfw_payment_add_modal_tapped_back";
})(BillingPaymentCardTrackingEvents || (BillingPaymentCardTrackingEvents = {}));
export var ContactSalesEvents;
(function (ContactSalesEvents) {
    ContactSalesEvents["PAGE_VIEW"] = "work_portal_contact_sales_page_view";
    ContactSalesEvents["MARKETING_SUBMIT_LEAD_SUCESS"] = "work_marketing_lead_form_submit_success";
    ContactSalesEvents["MARKETING_SUBMIT_LEAD_ERROR"] = "work_marketing_lead_form_submit_error";
    ContactSalesEvents["MARKETING_LEAD_FORM_BACK_CLICK"] = "work_marketing_lead_form_back_click";
    ContactSalesEvents["CONTACT_SALES_CLICK"] = "work_portal_contact_sales_click";
})(ContactSalesEvents || (ContactSalesEvents = {}));
export var DashPassEvents;
(function (DashPassEvents) {
    DashPassEvents["SELF_SERVE_BENEFIT_ACTIVATION"] = "self_serve_benefit_activation";
    DashPassEvents["SELF_SERVE_BENEFIT_DEACTIVATION"] = "self_serve_benefit_deactivation";
    DashPassEvents["SELF_SERVE_DASHPASS_PAGE_VIEW"] = "self_serve_dashpass_page_view";
    DashPassEvents["SUBSCRIBED"] = "dashpass_subscribed";
    DashPassEvents["SUBSCRIBED_GET_HELP_CLICK"] = "dashpass_subscribed_get_help_click";
    DashPassEvents["UNSUBSCRIBED"] = "dashpass_unsubscribed";
    DashPassEvents["UNSUBSCRIBED_LEARN_MORE_CLICK"] = "dashpass_unsubscribed_learn_more_click";
})(DashPassEvents || (DashPassEvents = {}));
export var EmployeesEvents;
(function (EmployeesEvents) {
    EmployeesEvents["REMOVE_MEMBERS"] = "workportal_remove_members";
    EmployeesEvents["SUBMIT_ADD_MEMBERS"] = "workportal_submit_add_members";
})(EmployeesEvents || (EmployeesEvents = {}));
export var GroupsEvents;
(function (GroupsEvents) {
    GroupsEvents["CLICK_CREATE_GROUP"] = "workportal_click_create_group";
    GroupsEvents["GROUPS"] = "workportal_groups";
    GroupsEvents["SUBMIT_ADD_GROUP"] = "workportal_submit_add_group";
    GroupsEvents["SUBMIT_DELETE_GROUP"] = "workportal_submit_delete_group";
    GroupsEvents["SUBMIT_EDIT_GROUP"] = "workportal_submit_edit_group";
})(GroupsEvents || (GroupsEvents = {}));
export var GroupsMembersEvents;
(function (GroupsMembersEvents) {
    GroupsMembersEvents["GROUPS_MEMBERS_LIST"] = "workportal_groups_members_list";
    GroupsMembersEvents["SUBMIT_REMOVE_GROUP_MEMBER"] = "workportal_submit_remove_group_member";
    GroupsMembersEvents["ADD_MODAL_SUBMIT_EMAILS"] = "work_portal_add_to_group_submit_emails";
    GroupsMembersEvents["ADD_MODAL_INVITE_CLICK"] = "workportal_add_to_group_invite_to_team_and_group_click";
    GroupsMembersEvents["ADD_MODAL_DO_NOT_INVITE_CLICK"] = "work_portal_add_to_group_do_not_invite_click";
    GroupsMembersEvents["ADD_MODAL_INFORM_CANNOT_ADD"] = "work_portal_add_to_group_show_members_cannot_be_added";
    GroupsMembersEvents["ADD_MEMBERS_SUCCESS"] = "work_portal_add_members_success";
})(GroupsMembersEvents || (GroupsMembersEvents = {}));
export var GroupOrdersAdminEvents;
(function (GroupOrdersAdminEvents) {
    GroupOrdersAdminEvents["GROUP_ORDERS_START"] = "work_portal_group_orders_start";
    GroupOrdersAdminEvents["ADD_STORES_PAGE_LOAD"] = "work_portal_add_stores_page_load";
    GroupOrdersAdminEvents["ADD_STORES_STORE_IMPRESSIONS"] = "work_portal_add_stores_page_store_impressions";
    GroupOrdersAdminEvents["ADD_STORES_STORE_ADDED"] = "work_portal_add_stores_page_store_added";
    GroupOrdersAdminEvents["ADD_STORES_PAGE_EXIT"] = "work_portal_add_stores_page_exit";
    GroupOrdersAdminEvents["ADD_STORES_STORE_CLICK"] = "work_portal_add_stores_page_store_click";
    GroupOrdersAdminEvents["ADD_STORES_FILTER_CLICK"] = "work_portal_add_stores_page_filter_click";
    GroupOrdersAdminEvents["ADD_STORES_FILTER_SELECT"] = "work_portal_add_stores_page_filter_select_click";
    GroupOrdersAdminEvents["CREATE_GROUP_ORDERS_CLICK"] = "work_portal_create_group_orders_click";
    GroupOrdersAdminEvents["CREATE_GROUP_ORDERS"] = "work_portal_create_group_orders";
    GroupOrdersAdminEvents["VIEW_GROUP_CART"] = "work_portal_admin_calendar_view_group_cart";
    GroupOrdersAdminEvents["ENTER_DELIVERY_ADDRESS_SAVE"] = "work_portal_enter_delivery_address_save";
    GroupOrdersAdminEvents["SHARE_MEAL_CALENDAR_BUTTON_CLICK"] = "work_portal_share_meal_calendar_button_click";
    GroupOrdersAdminEvents["COPY_CALENDAR_LINK_BUTTON_CLICK"] = "work_portal_copy_calendar_link_button_click";
    GroupOrdersAdminEvents["ADMIN_CALENDAR_CANCEL_GROUP_ORDER"] = "work_portal_admin_calendar_cancel_group_order";
    GroupOrdersAdminEvents["ADMIN_CALENDAR_VIEW_GROUP_ORDER_RECEIPT"] = "work_portal_admin_calendar_view_group_order_receipt";
})(GroupOrdersAdminEvents || (GroupOrdersAdminEvents = {}));
export var GroupOrdersEvents;
(function (GroupOrdersEvents) {
    GroupOrdersEvents["PAGE_VIEW"] = "work_portal_go_marketing_page_view";
    GroupOrdersEvents["START_ORDER_CLICK"] = "work_portal_go_start_ordering_click";
})(GroupOrdersEvents || (GroupOrdersEvents = {}));
export var HeaderEvents;
(function (HeaderEvents) {
    HeaderEvents["CLICK_SETTINGS"] = "workportal_click_settings";
})(HeaderEvents || (HeaderEvents = {}));
export var JoinPageEvents;
(function (JoinPageEvents) {
    JoinPageEvents["VIEW_JOIN_PAGE_PENDING"] = "workportal_view_join_page_pending";
    JoinPageEvents["VIEW_JOIN_PAGE_SUCCESS"] = "workportal_view_join_page_success";
})(JoinPageEvents || (JoinPageEvents = {}));
export var JoinV2PageEvents;
(function (JoinV2PageEvents) {
    JoinV2PageEvents["WORK_PORTAL_JOIN_PAGE_V2_PAGE_LOAD"] = "work_portal_join_page_v2_page_load";
    JoinV2PageEvents["WORK_PORTAL_JOIN_PAGE_V2_DDFB_IDENTITY_SUCCESS"] = "work_portal_join_page_v2_ddfb_identity_success";
    JoinV2PageEvents["WORK_PORTAL_JOIN_PAGE_V2_JOIN_TEAM_ACCOUNT_SUCCESS"] = "work_portal_join_page_v2_join_team_account_success";
    JoinV2PageEvents["WORK_PORTAL_JOIN_PAGE_V2_JOIN_TEAM_ACCOUNT_FAILURE"] = "work_portal_join_page_v2_join_team_account_failure";
    JoinV2PageEvents["WORK_PORTAL_JOIN_PAGE_V2_USE_DEFAULT_ACCOUNT_CLICK"] = "work_portal_join_page_v2_use_default_account_click";
    JoinV2PageEvents["WORK_PORTAL_JOIN_PAGE_V2_USE_ANOTHER_ACCOUNT_CLICK"] = "work_portal_join_page_v2_use_another_account_click";
    JoinV2PageEvents["WORK_PORTAL_JOIN_PAGE_V2_LANDING_PAGE_LOAD"] = "work_portal_join_page_v2_landing_page_load";
    JoinV2PageEvents["WORK_PORTAL_JOIN_PAGE_V2_LANDING_PAGE_RESEND_INVITE_ERROR"] = "work_portal_join_page_v2_landing_page_resend_invite_error";
    JoinV2PageEvents["WORK_PORTAL_JOIN_PAGE_V2_LANDING_PAGE_RESEND_INVITE_SUCCESS"] = "work_portal_join_page_v2_landing_page_resend_invite_success";
})(JoinV2PageEvents || (JoinV2PageEvents = {}));
export var MealBudgetsEvents;
(function (MealBudgetsEvents) {
    MealBudgetsEvents["CLICK_ADD_BUDGET"] = "workportal_click_add_budget";
    MealBudgetsEvents["DELETE_BUDGET"] = "workportal_delete_budget";
    MealBudgetsEvents["EDIT_BUDGET"] = "workportal_edit_budget";
    MealBudgetsEvents["EXPENSED_MEALS_LEARN_MORE_CLICK"] = "expensed_meals_learn_more_click";
    MealBudgetsEvents["EXPENSED_MEALS_UNSUBSCRIBED"] = "expensed_meals_unsubscribed";
    MealBudgetsEvents["SUBMIT_ADD_BUDGET"] = "workportal_submit_add_budget";
    MealBudgetsEvents["VIEW_BUDGETS"] = "workportal_view_budgets";
    MealBudgetsEvents["BUDGET_REMINDER_MODAL_VIEWED"] = "work_portal_budget_reminder_modal_viewed";
    MealBudgetsEvents["BUDGET_CREATION_REMINDER"] = "work_portal_budget_creation_reminder";
    MealBudgetsEvents["BUDGET_CREATION_REMINDER_CANCELLED"] = "work_portal_budget_creation_reminder_cancelled";
    MealBudgetsEvents["BUDGET_REMINDER_AUTO_TRIGGER_SUCCESS"] = "work_portal_budget_reminder_auto_trigger_success";
    MealBudgetsEvents["BUDGET_REMINDER_AUTO_TRIGGER_FAILURE"] = "work_portal_budget_reminder_auto_trigger_failure";
})(MealBudgetsEvents || (MealBudgetsEvents = {}));
export var NavigationEvents;
(function (NavigationEvents) {
    NavigationEvents["NAV_ITEM_CLICK"] = "work_portal_nav_item_click";
})(NavigationEvents || (NavigationEvents = {}));
export var OnboardingEvents;
(function (OnboardingEvents) {
    OnboardingEvents["SELECTION_PAGE_VIEW"] = "work_portal_onboarding_selection_page_view";
    OnboardingEvents["SETUP_SELECTED_SUBMIT"] = "work_portal_onboarding_setup_selected_submit";
    OnboardingEvents["QUICK_SETUP_SUBMIT"] = "work_portal_onboarding_quick_setup_submit";
    OnboardingEvents["CREATE_BUDGET_SUCCESS"] = "work_portal_onboarding_create_budget_success";
    OnboardingEvents["CREATE_BUDGET_FAILURE"] = "work_portal_onboarding_create_budget_failure";
    OnboardingEvents["SUCCESS_PAGE_VIEW"] = "work_portal_onboarding_success_page_view";
    OnboardingEvents["ACTIONS_CLICK"] = "work_portal_onboarding_redirect_actions_click";
    OnboardingEvents["STEP_CLICK"] = "work_portal_onboarding_step_click";
})(OnboardingEvents || (OnboardingEvents = {}));
export var OptInEvents;
(function (OptInEvents) {
    OptInEvents["PAGE_VIEW"] = "workportal_opt_in_page_view";
    OptInEvents["SUBMIT_EMAIL"] = "workportal_opt_in_submit_email";
})(OptInEvents || (OptInEvents = {}));
export var OrderHistoryEvents;
(function (OrderHistoryEvents) {
    OrderHistoryEvents["ORDER_HISTORY"] = "workportal_order_history";
    OrderHistoryEvents["DOWNLOAD_BILLING_HISTORY"] = "download_billing_history";
})(OrderHistoryEvents || (OrderHistoryEvents = {}));
export var PlaceOrderEvents;
(function (PlaceOrderEvents) {
    PlaceOrderEvents["PAGE_VIEW"] = "work_portal_place_order_page_view";
    PlaceOrderEvents["START_ORDER_CLICK"] = "work_portal_place_order_start_order_click";
    PlaceOrderEvents["CREATE_BUDGET_SUCCESS"] = "work_portal_place_order_create_budget_success";
    PlaceOrderEvents["CREATE_BUDGET_FAIL"] = "work_portal_place_order_create_budget_fail";
    PlaceOrderEvents["FAQ_VIEW"] = "work_portal_place_order_faq_view";
})(PlaceOrderEvents || (PlaceOrderEvents = {}));
export var SelfServeProductOptionsEvents;
(function (SelfServeProductOptionsEvents) {
    SelfServeProductOptionsEvents["PAGE_VIEW"] = "work_portal_self_serve_product_options_page_view";
    SelfServeProductOptionsEvents["RETURN_TO_SELF_SERVE"] = "work_portal_self_serve_return_to_self_serve";
    SelfServeProductOptionsEvents["DASHPASS_SIGN_UP"] = "work_portal_self_serve_dashpass_sign_up";
    SelfServeProductOptionsEvents["EXPENSED_MEALS_SIGN_UP"] = "work_portal_self_serve_expensed_meals_sign_up";
    SelfServeProductOptionsEvents["VIEW_TALK_SALES_MODAL"] = "work_portal_self_serve_view_talk_to_sales_modal";
})(SelfServeProductOptionsEvents || (SelfServeProductOptionsEvents = {}));
export var SelfServeSignupTeamEvents;
(function (SelfServeSignupTeamEvents) {
    SelfServeSignupTeamEvents["DASHPASS_CREATE_TEAM"] = "work_portal_self_serve_dashpass_create_team";
    SelfServeSignupTeamEvents["DASHPASS_CREATE_TEAM_SUCCESS"] = "work_portal_self_serve_dashpass_create_team_success";
    SelfServeSignupTeamEvents["EXPENSED_MEALS_CREATE_TEAM"] = "work_portal_self_serve_expensed_meals_create_team";
    SelfServeSignupTeamEvents["EXPENSED_MEALS_CREATE_TEAM_SUCCESS"] = "work_portal_self_serve_expensed_meals_create_team_success";
    SelfServeSignupTeamEvents["CREATE_TEAM_PAGE_LOADING"] = "work_portal_create_team_page_loading";
    SelfServeSignupTeamEvents["CREATE_TEAM_PAGE_VIEW"] = "work_portal_create_team_page_view";
})(SelfServeSignupTeamEvents || (SelfServeSignupTeamEvents = {}));
export var TeamNotFoundEvents;
(function (TeamNotFoundEvents) {
    TeamNotFoundEvents["VIEW_EMAIL_NOT_FOUND_PAGE"] = "workportal_view_email_not_found_page";
})(TeamNotFoundEvents || (TeamNotFoundEvents = {}));
export var QuizEvents;
(function (QuizEvents) {
    QuizEvents["PAGE_VIEW"] = "work_portal_self_serve_product_options_page_view";
    QuizEvents["CONTACT_SALES_CLICK"] = "work_portal_product_options_contact_sales_click";
    QuizEvents["EMAIL_SUBMIT"] = "work_portal_quiz_email_submit";
    QuizEvents["START_OVER_CLICK"] = "work_portal_quiz_start_over_click";
    QuizEvents["CATERING_ORDER_NOW_CLICK"] = "work_portal_quiz_catering_order_now_click";
    QuizEvents["GO_ORDER_NOW_CLICK"] = "work_portal_quiz_go_order_now_click";
    QuizEvents["GO_HOW_TO_PLACE_MODAL_OPEN"] = "work_portal_quiz_go_how_to_place_modal_open";
    QuizEvents["EM_ENROLL_NOW_CLICK"] = "work_portal_quiz_expensed_meals_enroll_now_click";
    QuizEvents["RECOMMENDATION_VIEW"] = "work_portal_quiz_recommended_product_view";
    QuizEvents["OPTION_RESPONSE_SUBMIT"] = "work_portal_quiz_option_submit";
    QuizEvents["BACK_CLICK"] = "work_portal_quiz_back_click";
})(QuizEvents || (QuizEvents = {}));
export var MembershipActivationEvents;
(function (MembershipActivationEvents) {
    MembershipActivationEvents["RESEND_INVITES_SUCCESS"] = "work_portal_send_membership_activation_reminders_success";
    MembershipActivationEvents["RESND_INVITES_FAILED"] = "work_portal_send_membership_activation_reminders_failed";
    MembershipActivationEvents["CLOSE_RESEND_INVITES_BANNER"] = "work_portal_close_membership_activation_reminders_banner";
})(MembershipActivationEvents || (MembershipActivationEvents = {}));
export var HomePageEvents;
(function (HomePageEvents) {
    HomePageEvents["PAGE_VIEW"] = "work_portal_home_page_view";
    HomePageEvents["PRODUCT_OPTION_CLICK"] = "work_portal_home_product_option_click";
})(HomePageEvents || (HomePageEvents = {}));
export var EmployeeCalendarEvents;
(function (EmployeeCalendarEvents) {
    EmployeeCalendarEvents["PAGE_VIEW"] = "work_portal_employee_calendar_page_load";
    EmployeeCalendarEvents["JOIN_GROUP_ORDER"] = "work_portal_employee_join_group_order";
    EmployeeCalendarEvents["TRACK_ORDER_CLICK"] = "work_portal_track_order_click";
})(EmployeeCalendarEvents || (EmployeeCalendarEvents = {}));
export var VoucherEvents;
(function (VoucherEvents) {
    VoucherEvents["VOUCHER_CHANGE_PAYMENT_DEFAULT_CONFIRM_CLICK"] = "work_portal_voucher_change_payment_default_confirm_click";
    VoucherEvents["VOUCHER_CHANGE_PAYMENT_DEFAULT_MODAL_LOAD"] = "work_portal_voucher_change_payment_default_modal_load";
    VoucherEvents["VOUCHERS_HOME_PAGE_LOAD"] = "work_portal_voucher_home_page_load";
    VoucherEvents["VOUCHERS_HOME_ADD_PAYMENT_CLICK"] = "work_portal_voucher_home_add_payment_click";
    VoucherEvents["VOUCHER_DETAIL_CLICK"] = "work_portal_voucher_detail_click";
    VoucherEvents["VOUCHER_DETAIL_PAGE_LOAD"] = "work_portal_voucher_detail_page_load";
    VoucherEvents["DELETE_VOUCHER_CLICK"] = "work_portal_voucher_delete_voucher_click";
    VoucherEvents["DELETE_VOUCHER_CONFIRM_CLICK"] = "work_portal_voucher_delete_voucher_confirm_click";
    VoucherEvents["NEWLY_SHAREABLE_VOUCHERS"] = "work_portal_voucher_newly_shareable_voucher";
    VoucherEvents["VOUCHER_HOME_PAGE_CREATE_VOUCHER_CLICK"] = "work_portal_voucher_create_click";
    VoucherEvents["VOUCHER_HOME_PAGE_CREATE_VOUCHER_PAGE_LOAD"] = "work_portal_voucher_create_voucher_page_load";
    VoucherEvents["VOUCHER_HOME_PAGE_CREATE_VOUCHER_FAILURE"] = "work_portal_voucher_create_voucher_failure";
    VoucherEvents["VOUCHER_HOME_PAGE_CREATE_VOUCHER_SUCCESS"] = "work_portal_voucher_create_voucher_success";
    VoucherEvents["VOUCHER_HOME_PAGE_EDIT_VOUCHER_CLICK"] = "work_portal_voucher_edit_click";
    VoucherEvents["VOUCHER_HOME_PAGE_EDIT_VOUCHER_PAGE_LOAD"] = "work_portal_voucher_edit_voucher_page_load";
    VoucherEvents["VOUCHER_HOME_PAGE_EDIT_VOUCHER_FAILURE"] = "work_portal_voucher_edit_voucher_failure";
    VoucherEvents["VOUCHER_HOME_PAGE_EDIT_VOUCHER_SUCCESS"] = "work_portal_voucher_edit_voucher_success";
    VoucherEvents["VOUCHER_FORM_SAVE_CLICK"] = "work_portal_voucher_form_save_click";
    VoucherEvents["VOUCHER_FORM_SAVE_CLICK_ERROR"] = "work_portal_voucher_form_save_click_error";
})(VoucherEvents || (VoucherEvents = {}));
export var VoucherShareEvents;
(function (VoucherShareEvents) {
    VoucherShareEvents["CONTINUE_PAYMENT_CLICK"] = "work_portal_voucher_click_continue_payment";
    VoucherShareEvents["COPY_LINK"] = "work_portal_voucher_click_copy_link";
    VoucherShareEvents["SHARE_BY_EMAIL_CLICK"] = "work_portal_voucher_click_share_by_email";
    VoucherShareEvents["SHARE_BY_LINK_CLICK"] = "work_portal_voucher_click_share_by_link";
    VoucherShareEvents["SHARE_VOUCHER_BEGIN"] = "work_portal_voucher_click_share_voucher_begin";
    VoucherShareEvents["SHARE_VOUCHER_EMAILS"] = "work_portal_voucher_click_share_voucher_emails";
    VoucherShareEvents["ERROR_MAX_RECIPIENTS"] = "work_portal_voucher_error_max_recipients";
    VoucherShareEvents["ADD_RECIPIENTS_CANCEL_CLICK"] = "work_portal_voucher_add_more_recipients_modal_cancel_click";
    VoucherShareEvents["ADD_RECIPIENTS_EDIT_CLICK"] = "work_portal_voucher_add_more_recipients_modal_edit_click";
    VoucherShareEvents["ADD_RECIPIENTS_LOAD"] = "work_portal_voucher_add_more_recipients_modal_load";
    VoucherShareEvents["SHARE_LATER_CLICK"] = "work_portal_voucher_click_share_later";
    VoucherShareEvents["SHARE_MODAL_LOAD"] = "work_portal_voucher_share_modal_load";
    VoucherShareEvents["SHARE_OPTION_MODAL_LOAD"] = "work_portal_voucher_share_option_modal_load";
    VoucherShareEvents["SHARE_OPTION_MODAL_CONFIRM_CLICK"] = "work_portal_voucher_share_option_modal_confirm_click";
    VoucherShareEvents["GENERIC_LINK_MODAL_LOAD"] = "work_portal_voucher_generic_link_modal_load";
    VoucherShareEvents["COPY_LINK_CLICK"] = "work_portal_voucher_copy_link_click";
    VoucherShareEvents["COPY_MESSAGE_WITH_LINK_CLICK"] = "work_portal_voucher_copy_message_with_link_click";
    VoucherShareEvents["CUSTOM_COPY_TEXT_SELECTION"] = "work_portal_voucher_custom_copy_text_selection";
    VoucherShareEvents["UNIQUE_LINK_MODAL_LOAD"] = "work_portal_voucher_send_email_unique_link_modal_load";
})(VoucherShareEvents || (VoucherShareEvents = {}));
export var VoucherParticipantEvents;
(function (VoucherParticipantEvents) {
    VoucherParticipantEvents["PREVIEW_VOUCHER_PAGE_LOAD"] = "work_portal_voucher_info_page_load";
    VoucherParticipantEvents["PREVIEW_VOUCHER_CLICK_ACCEPT"] = "work_portal_voucher_info_accept_click";
    VoucherParticipantEvents["RECIPIENT_FAILURE"] = "work_portal_voucher_recipient_failure";
    VoucherParticipantEvents["ACCEPT_VOUCHER_PAGE_LOAD"] = "work_portal_voucher_accept_page_load";
    VoucherParticipantEvents["ACCEPT_VOUCHER_SUCCESS"] = "work_portal_voucher_accept_success";
    VoucherParticipantEvents["USE_CURRENT_ACCOUNT_CLICK"] = "work_portal_voucher_info_current_account_click";
    VoucherParticipantEvents["USE_ANOTHER_ACCOUNT_CLICK"] = "work_portal_voucher_info_another_account_click";
})(VoucherParticipantEvents || (VoucherParticipantEvents = {}));
